import { useMutation } from "react-query";
import {
  createBankAccount,
  exportVatLogs,
  deleteAccount,
  updateBankAccount,
  createChartAccount,
  updateChartAccount,
  updateAccountMapping,
  createJournalEntry,
  draftJournalEntry,
  approveJournalEntry,
  declineJournalEntry,
  voidJournalEntry,
  copyJournalEntry,
  createCashBankJournalEntry,
  exportAccountStatement,
} from "../../../services/accounting";
import { resolveAccountNumber } from "../../../services/transfers";

export const useCreateBankAccountMutation = () => {
  return useMutation((data) => createBankAccount(data));
};

export const useUpdateBankAccountMutation = () => {
  return useMutation((data) => updateBankAccount(data));
};

export const useCreateChartAccountMutation = () => {
  return useMutation((data) => createChartAccount(data));
};

export const useUpdateChartAccountMutation = () => {
  return useMutation((data) => updateChartAccount(data));
};

export const useDeleteAccountMutation = () => {
  return useMutation((data) => deleteAccount(data));
};

export const useCreateCashBankJournalEntry = () => {
  return useMutation((data) => createCashBankJournalEntry(data));
};

export const useResolveBankAccount = () => {
  return useMutation((data) => resolveAccountNumber(data));
};

export const useExportVatLogsMutation = () => {
  return useMutation((data) => exportVatLogs(data));
};

export const useUpdateAccountMappingMutation = () => {
  return useMutation((data) => updateAccountMapping(data));
};

export const useCreateJournalEntryMutation = () => {
  return useMutation((data) => createJournalEntry(data));
};

export const useDraftJournalEntryMutation = () => {
  return useMutation((data) => draftJournalEntry(data));
};

export const useApproveJournalEntry = () => {
  return useMutation((data) => approveJournalEntry(data));
};

export const useDeclineJournalEntry = () => {
  return useMutation((data) => declineJournalEntry(data));
};

export const useVoidJournalEntry = () => {
  return useMutation((data) => voidJournalEntry(data));
};

export const useCopyJournalEntry = () => {
  return useMutation((data) => copyJournalEntry(data));
};

export const useExportAccountStatementMutation = () => {
  return useMutation((data) => exportAccountStatement(data));
};
